export enum StrapiComponentTypes {
  TimedFeatureList = "common.timed-feature-list",
  SingleFeatureWithImage = "category.image-text-block",
  TileWrapper = "common.tile-wrapper",
  ImageWrapper = "common.image-wrapper",
  TestimonialSlider = "common.testimonial-slider",
  LastScrollCTA = "common.last-scroll-cta",
  FeatureStats = "common.feature-stats",
  TreeWithThreeTiles = "common.tree-with-three-tiles",
  FAQ = "common.faq",
  Timeline = "common.timeline",
  Steps = "common.steps",
  CardWrapper = "common.card-wrapper",
  QuestionAnswer = "common.question-answer",
  BentoGrid = "common.bento-highlighter",
  ThreePointHighLighter = "common.three-point-highlighter",
  HpStats = "common.hp-stats",
  IFrameWrapper = "common.i-frame-wrapper",
  FeaturedPodcast = "common.featured-podcast",
  FormWithGifOrVideo = "common.form-with-gif-banner",
  TimeDelta = "common.time-delta",
}
